module.exports = __webpack_public_path__ + "static/img/design7.9b30396.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/design7.png
// module id = iL5p
// module chunks = 1